/**
 * Notification body text; uses the shared Markdown pipeline (default link behavior, no custom onLinkClick).
 */

import { Markdown } from "@components/Markdown";
import { cn } from "utils";

import { useJsonRenderRuntimeContext } from "../jsonRender/JsonRenderRuntimeContext";

export interface NotificationTextProps {
  text: string;
  className?: string;
}

export const NotificationText: React.FC<NotificationTextProps> = ({
  text,
  className = "",
}) => {
  const renderContext = useJsonRenderRuntimeContext();
  const isInvestNextMovesScene = renderContext?.scene === "invest-nextmoves";

  return (
    <Markdown
      className={cn(
        isInvestNextMovesScene
          ? "body_m text-content_secondary [&_p]:!mt-0 [&_p]:!mb-0 [&_p]:!body_m [&_p]:!text-content_secondary"
          : "[&_a]:!body_output [&_div]:!body_output_m [&_h1]:!mb-0 [&_h2]:!mb-0 [&_h3]:!mb-0 [&_p]:!mt-3 [&_p]:!mb-0 [&_p]:!body_output_m [&_li]:!body_output_m [&_span]:!body_medium_m [&_li]:!pt-2 [&_li]:!pb-0 [&_td_div]:!line-height-[20px]",
        className,
      )}
    >
      {text}
    </Markdown>
  );
};
